module.exports = __webpack_public_path__ + "media/images/amenities_icons/cat_friendly-f52e3926500c28ae260de1d1d6518d4b.svg";